import { useEffect } from "react";
import { PortfolioModernView } from "./PortfolioLayouts/PortfolioModernView";
import { useStoreState } from "../../util/util";
import { useAuthContext } from "../../components/Auth";
import { Redirect, useHistory } from "react-router-dom";
import { useRoutePath } from "../../util/Routing";

// Re-export from filterStateManager for backward compatibility
export {
  groupPortfolioParamsByKey,
  applyFiltersToURL,
} from "../../util/filterStateManager";

export const PublicIndexWrapper = () => {
  const { storefront_metadata } = useStoreState();
  const { roleIsSomeKindOfBuyer } = useAuthContext();
  const history = useHistory();
  const { adminPath, storePath } = useRoutePath();
  const { route_configuration } = storefront_metadata;

  const portfolioRoute = route_configuration.find(
    (route) => route.route === "portfolio"
  );

  useEffect(() => {
    if (roleIsSomeKindOfBuyer) {
      history.push(
        `${adminPath}/pim/products${
          sessionStorage.getItem("products_search") ?? ""
        }`
      );
    }
  }, [roleIsSomeKindOfBuyer, adminPath, history]);

  if (portfolioRoute?.enabled === false) {
    return <Redirect to={`${storePath}/login`} />;
  }

  // Always use the unified portfolio view (formerly "modern" view)
  return <PortfolioModernView isPublic />;
};
